var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.097 18.334H51.3979C60.1669 18.334 64.5516 18.334 67.2756 21.1299C69.2372 23.143 69.7864 26.0395 69.9401 30.8629H23.5549C23.7087 26.0395 24.2579 23.143 26.2193 21.1299C28.9435 18.334 33.328 18.334 42.097 18.334ZM51.3979 56.5175H42.097C33.328 56.5175 28.9435 56.5175 26.2193 53.7215C23.4951 50.9257 23.4951 46.4256 23.4951 37.4257C23.4951 36.3711 23.4951 33.2569 23.4995 32.3214H69.9954C69.9998 33.2569 69.9998 36.3711 69.9998 37.4257V37.4258C69.9998 46.4256 69.9998 50.9257 67.2756 53.7215C64.5516 56.5175 60.1669 56.5175 51.3979 56.5175Z",
    fill: "#2CAAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0518 48.0314C31.0518 47.0429 31.8325 47.3022 32.7957 47.3022H42.0966C43.0597 47.3022 43.8406 47.0429 43.8406 48.0314C43.8406 49.0199 43.0597 48.7606 42.0966 48.7606H32.7957C31.8325 48.7606 31.0518 49.0199 31.0518 48.0314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.166 48.0314C46.166 47.0429 46.9468 47.3022 47.9099 47.3022H51.3978C52.3609 47.3022 53.1417 47.0429 53.1417 48.0314C53.1417 49.0199 52.3609 48.7606 51.3978 48.7606H47.9099C46.9468 48.7606 46.166 49.0199 46.166 48.0314Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1057 19.7898L20.6824 13.2131C26.883 7.01251 29.9834 3.91206 33.8866 3.9629C36.6971 3.99933 39.1336 5.65909 42.653 8.96113L9.85375 41.7604C6.55176 38.2409 4.89197 35.8045 4.85544 32.9941C4.80473 29.0908 7.90503 25.9905 14.1057 19.7898ZM47.6822 40.2129L41.1055 46.7896C34.9048 52.9903 31.8045 56.0906 27.9012 56.0398C23.998 55.9892 20.8159 52.8071 14.4521 46.4433C13.7063 45.6976 11.5042 43.4954 10.8458 42.8308L43.7234 9.95326C44.388 10.6116 46.5901 12.8138 47.3358 13.5595L47.3359 13.5595C53.6997 19.9233 56.8818 23.1054 56.9324 27.0086C56.9832 30.9119 53.8828 34.0123 47.6822 40.2129Z",
    fill: "#2CAAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2951 48.5998C26.5962 47.9009 27.3316 47.5321 28.0127 46.8511L34.5894 40.2743C35.2704 39.5933 35.6392 38.8578 36.3382 39.5568C37.0371 40.2557 36.3017 40.6245 35.6207 41.3056L29.0439 47.8823C28.3629 48.5634 27.9941 49.2988 27.2951 48.5998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9826 37.9123C37.2837 37.2134 38.0191 36.8446 38.7002 36.1636L41.1664 33.6973C41.8475 33.0163 42.2163 32.2808 42.9152 32.9798C43.6142 33.6787 42.8787 34.0475 42.1977 34.7285L39.7314 37.1948C39.0504 37.8758 38.6816 38.6113 37.9826 37.9123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupWalletIcon);
export default __webpack_public_path__ + "static/media/popup-wallet-icon.1bc9da6453f0a696b1345cc95ad8dbff.svg";
export { ForwardRef as ReactComponent };